import {firstName, lastName} from '../../field-templates/names/names';
import {accountNumber, sortCode} from '../../field-templates/payment-methods/bacs/bacs';
import {buildField} from '../../field-templates/fieldBuilder';

export default {
    groups: [
        {
            styleClasses: "row",
            fields: [buildField(firstName), buildField(lastName)],
        },
        {
            styleClasses: "row",
            fields: [buildField(accountNumber), buildField(sortCode)],
        },
    ]
}
